import { useCallback, useState } from 'react';
import { useComponentTranslations } from 'js/hooks/component';
import { ERRORS } from 'js/components/main/ReCaptcha';

export const useReCaptcha = () => {
    const translate = useComponentTranslations();
    const [reCaptchaError, setReCaptchaError] = useState('');
    const [isReCaptchaVisible, setIsReCaptchaVisible] = useState(false);

    const showReCaptcha = useCallback(() => setIsReCaptchaVisible(true), []);

    const onReCaptchaValidate = useCallback(() => setIsReCaptchaVisible(false), []);

    const onReCaptchaError = useCallback(({ errorCode }: { errorCode: number }) => {
        if (errorCode === ERRORS.SCRIPT_LOADING_ERROR.errorCode) {
            setIsReCaptchaVisible(false);
        }

        setReCaptchaError(translate('playtech.mobile.system.recaptcha.error.technicalError'));
    }, [translate]);

    return {
        reCaptchaError,
        isReCaptchaVisible,
        onReCaptchaError,
        onReCaptchaValidate,
        showReCaptcha
    };
};
